export const joinIds = (...ids: (string | number | undefined)[]) => {
  return ids.filter((id) => !!id).join("-")
}

export const formatId = (id: string) => {
  return id.toLowerCase().replaceAll(" ", "-")
}
